<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="pageTitle">
          <template v-slot:preview>
            <b-form ref="form" lazy-validation class="row">
              <b-container class="bv-example-row">
                <!-- Khối 1: Thông tin chung -->
                <b-row>
                  <b-col cols="6">
                    <b-form-group class="required-control">
                      <label>Tên chương trình</label>
                      <b-form-input
                        size="sm"
                        v-model="$v.mainModel.name.$model"
                        :state="validateState('name')"
                        placeholder="Nhập tên chương trình"
                      ></b-form-input>
                      <b-form-invalid-feedback
                        >Vui lòng nhập tên chương trình</b-form-invalid-feedback
                      >
                    </b-form-group>
                    <b-form-group>
                      <label>Mô tả</label>
                      <b-form-textarea
                        v-model="mainModel.description"
                        placeholder="Nhập mô tả"
                        rows="5"
                        :max-length="255"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-row>
                      <b-col cols="6">
                        <b-form-group class="required-control">
                          <label>Từ ngày</label>
                          <date-picker
                            placeholder="Từ ngày"
                            class="form-control form-control-sm"
                            :config="dpConfigs.date"
                            v-model="mainModel.startDate"
                          ></date-picker>
                        </b-form-group>
                      </b-col>
                      <b-col cols="6">
                        <b-form-group>
                          <label>Đến ngày</label>
                          <date-picker
                            placeholder="Đến ngày"
                            class="form-control form-control-sm"
                            :config="dpConfigs.date"
                            v-model="mainModel.endDate"
                          ></date-picker>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="6">
                        <b-form-group>
                          <label>Trạng thái</label>
                          <b-form-select
                            size="sm"
                            v-model="mainModel.status"
                            :options="allowedStatusOptions"
                            value-field="id"
                            text-field="name"
                          ></b-form-select>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>

                <!-- Khối 2: Phạm vi áp dụng -->
                <h4>Phạm vi áp dụng</h4>
                <div class="separator separator-dashed my-5"></div>

                <!-- type = 1: hai khối cửa hàng độc lập -->
                <b-row v-if="isStoreProgram">
                  <b-col cols="6">
                    <b-form-group>
                      <label>Cửa hàng bán lẻ</label>
                      <b-form-checkbox
                        class="mb-2"
                        v-model="mainModel.applyAllRetail"
                        @change="onToggleApplyAllRetail"
                      >
                        Áp dụng toàn bộ cửa hàng bán lẻ
                      </b-form-checkbox>
                      <vue-multi-select
                        v-if="!mainModel.applyAllRetail"
                        v-model="mainModel.retailStores"
                        :options="stores"
                        placeholder="Chọn cửa hàng bán lẻ"
                        option-label="name"
                      ></vue-multi-select>
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group>
                      <label>Cửa hàng bán buôn</label>
                      <b-form-checkbox
                        class="mb-2"
                        v-model="mainModel.applyAllWholesale"
                        @change="onToggleApplyAllWholesale"
                      >
                        Áp dụng toàn bộ cửa hàng bán buôn
                      </b-form-checkbox>
                      <vue-multi-select
                        v-if="!mainModel.applyAllWholesale"
                        v-model="mainModel.wholesaleStores"
                        :options="stores"
                        placeholder="Chọn cửa hàng bán buôn"
                        option-label="name"
                      ></vue-multi-select>
                    </b-form-group>
                  </b-col>
                </b-row>

                <!-- type = 3: chọn bộ phận -->
                <b-row v-else>
                  <b-col cols="4">
                    <b-form-group>
                      <label>Bộ phận</label>
                      <b-form-select
                        size="sm"
                        v-model="mainModel.departmentId"
                        :options="departments"
                        value-field="id"
                        text-field="name"
                      >
                        <template v-slot:first>
                          <b-form-select-option :value="null"
                            >-- Tất cả bộ phận --</b-form-select-option
                          >
                        </template>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>

                <!-- Khối 3: Chi tiết hoa hồng -->
                <h4>Chi tiết hoa hồng</h4>
                <div class="separator separator-dashed my-5"></div>
                <b-row class="mb-4">
                  <b-col md="6">
                    <label>Tìm nhóm hoa hồng:</label>
                    <vue-autosuggest
                      v-model="searchCategory"
                      :suggestions="filteredCategoryOptions"
                      @selected="onSelectedCategory"
                      :limit="10"
                      @input="onInputChangeCategory"
                      :input-props="{
                        id: 'autosuggest__input',
                        placeholder: 'Nhập tên nhóm hoa hồng',
                        style: 'border-radius:0px!important',
                      }"
                      :should-render-suggestions="
                        (size, loading) => size >= 0 && !loading
                      "
                    >
                      <template slot-scope="{ suggestion }">
                        <div>{{ suggestion.item.name }}</div>
                      </template>
                    </vue-autosuggest>
                  </b-col>
                  <b-col md="6" class="d-flex align-items-end">
                    <span class="text-muted">
                      Để trống Giá trị 1 / Giá trị 2 nghĩa là không giới hạn ở vế
                      đó.
                    </span>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <b-table
                      class="table-bordered table-hover col-md-12"
                      :fields="detailFields"
                      :items="mainModel.details"
                      show-empty
                      empty-text="Chưa có chi tiết hoa hồng nào"
                    >
                      <template v-slot:cell(count)="row">
                        <span>{{ row.index + 1 }}</span>
                      </template>
                      <template v-slot:cell(amount1)="row">
                        <b-input
                          type="text"
                          size="sm"
                          class="text-right"
                          placeholder="Không giới hạn"
                          v-model="row.item.amount1"
                          v-mask="mask"
                        ></b-input>
                      </template>
                      <template v-slot:cell(amountOperator1)="row">
                        <b-form-select
                          size="sm"
                          v-model="row.item.amountOperator1"
                          :options="operatorOptions"
                        ></b-form-select>
                      </template>
                      <template v-slot:cell(revenue)>
                        <div class="text-center font-weight-bold">DT</div>
                      </template>
                      <template v-slot:cell(amountOperator2)="row">
                        <b-form-select
                          size="sm"
                          v-model="row.item.amountOperator2"
                          :options="operatorOptions"
                        ></b-form-select>
                      </template>
                      <template v-slot:cell(amount2)="row">
                        <b-input
                          type="text"
                          size="sm"
                          class="text-right"
                          placeholder="Không giới hạn"
                          v-model="row.item.amount2"
                          v-mask="mask"
                        ></b-input>
                      </template>
                      <template v-slot:cell(employeeRates)="row">
                        <div
                          class="text-center commission-link"
                          @click="showRewardRateModal(row.item)"
                        >
                          Mức thưởng ({{
                            (row.item.employeeRates || []).length
                          }})
                        </div>
                      </template>
                      <template v-slot:cell(actions)="row">
                        <v-icon
                          small
                          class="text-danger"
                          @click="showRemoveDetailAlert(row.item)"
                          v-b-tooltip
                          title="Xóa"
                          >mdi-delete</v-icon
                        >
                      </template>
                    </b-table>
                  </b-col>
                </b-row>

                <!-- Khối 4: Loại trừ hóa đơn -->
                <h4>Loại trừ hóa đơn</h4>
                <div class="separator separator-dashed my-5"></div>
                <b-row class="mb-4">
                  <b-col md="3">
                    <b-input
                      size="sm"
                      placeholder="Mã hóa đơn"
                      v-model="exclusionForm.billNumber"
                    ></b-input>
                  </b-col>
                  <b-col md="5">
                    <b-input
                      size="sm"
                      placeholder="Lý do loại trừ"
                      v-model="exclusionForm.reason"
                    ></b-input>
                  </b-col>
                  <b-col md="2">
                    <b-button variant="secondary" size="sm" @click="addExclusion"
                      >Thêm</b-button
                    >
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <b-table
                      class="table-bordered table-hover col-md-12"
                      :fields="exclusionFields"
                      :items="mainModel.exclusions"
                      show-empty
                      empty-text="Chưa loại trừ hóa đơn nào"
                    >
                      <template v-slot:cell(count)="row">
                        <span>{{ row.index + 1 }}</span>
                      </template>
                      <template v-slot:cell(actions)="row">
                        <v-icon
                          small
                          class="text-danger"
                          @click="showRemoveExclusionAlert(row.item)"
                          v-b-tooltip
                          title="Xóa"
                          >mdi-delete</v-icon
                        >
                      </template>
                    </b-table>
                  </b-col>
                </b-row>
              </b-container>
            </b-form>

            <!-- Modal mức thưởng theo vị trí công việc -->
            <b-modal
              ref="reward-rate-modal"
              hide-footer
              size="lg"
              title="Mức thưởng theo vị trí công việc"
            >
              <b-row class="mb-4">
                <b-col md="3">
                  <span style="font-weight: 500">Nhóm hoa hồng:</span>
                </b-col>
                <b-col>
                  <span>{{ rewardRateModel.categoryName }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-4">
                <b-col md="6">
                  <b-form-select
                    size="sm"
                    v-model="selectedJobTitleId"
                    :options="availableJobTitles"
                    value-field="id"
                    text-field="name"
                  >
                    <template v-slot:first>
                      <b-form-select-option :value="null"
                        >-- Chọn vị trí công việc --</b-form-select-option
                      >
                    </template>
                  </b-form-select>
                </b-col>
                <b-col md="3">
                  <b-button
                    variant="secondary"
                    size="sm"
                    :disabled="!selectedJobTitleId"
                    @click="addRewardRate"
                    >Thêm vị trí</b-button
                  >
                </b-col>
              </b-row>
              <b-table
                class="table-bordered table-hover"
                :fields="rewardRateFields"
                :items="rewardRateModel.rows"
                show-empty
                empty-text="Chưa cấu hình mức thưởng cho vị trí nào"
              >
                <template v-slot:cell(rateType)="row">
                  <b-form-select
                    size="sm"
                    v-model="row.item.rateType"
                    :options="rateTypeOptions"
                  ></b-form-select>
                </template>
                <template v-slot:cell(value)="row">
                  <b-input
                    v-if="row.item.rateType === AMOUNT_TYPE.MONEY"
                    type="text"
                    size="sm"
                    class="text-right"
                    v-model="row.item.amount"
                    v-mask="mask"
                  ></b-input>
                  <b-input
                    v-else
                    type="number"
                    min="0"
                    max="100"
                    step="0.01"
                    size="sm"
                    class="text-right no-spinner"
                    v-model.number="row.item.percent"
                  ></b-input>
                </template>
                <template v-slot:cell(actions)="row">
                  <v-icon
                    small
                    class="text-danger"
                    @click="removeRewardRate(row.item)"
                    v-b-tooltip
                    title="Xóa"
                    >mdi-delete</v-icon
                  >
                </template>
              </b-table>
              <div class="mt-4">
                <b-button
                  style="width: 70px"
                  variant="primary"
                  size="sm"
                  @click="saveRewardRate"
                  >Lưu</b-button
                >
                <b-button
                  style="margin-left: 10px; width: 70px"
                  variant="secondary"
                  size="sm"
                  @click="hideRewardRateModal"
                  >Hủy</b-button
                >
              </div>
            </b-modal>

            <!-- Modal chi tiết lỗi chồng lấn -->
            <b-modal
              ref="overlap-modal"
              hide-footer
              size="lg"
              title="Chương trình bị chồng lấn"
            >
              <b-alert show variant="danger">
                Không thể lưu. Các phạm vi sau đã nằm trong chương trình khác
                cùng thời gian:
              </b-alert>
              <b-table
                class="table-bordered table-hover"
                :fields="overlapFields"
                :items="overlaps"
              >
                <template v-slot:cell(period)="row">
                  <span
                    >{{ formatShortDate(row.item.startDate) }} –
                    {{
                      row.item.endDate
                        ? formatShortDate(row.item.endDate)
                        : 'không giới hạn'
                    }}</span
                  >
                </template>
                <template v-slot:cell(scope)="row">
                  <span>{{ scopeName(row.item.scope) }}</span>
                </template>
              </b-table>
              <div class="mt-4">
                <b-button
                  variant="secondary"
                  size="sm"
                  @click="$refs['overlap-modal'].hide()"
                  >Đóng</b-button
                >
              </div>
            </b-modal>
          </template>
          <template v-slot:foot>
            <b-container class="bv-example-row">
              <b-row>
                <b-button
                  style="width: 70px"
                  variant="primary"
                  size="sm"
                  :disabled="isSubmitting"
                  @click="onSubmit"
                  >Lưu</b-button
                >
                <b-button
                  style="margin-left: 10px; width: 70px"
                  variant="secondary"
                  size="sm"
                  @click="onBack"
                  >Hủy</b-button
                >
              </b-row>
            </b-container>
          </template>
        </KTCodePreview>
      </div>
    </div>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import ApiService from '@/core/services/api.service';
import Swal from 'sweetalert2';
import decounce from 'debounce';
import moment from 'moment';
import datePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import VueMultiSelect from 'vue-simple-multi-select';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { TIME_TRIGGER } from '@/utils/constants';
import { OPERATOR_TYPE, AMOUNT_TYPE } from '@/utils/enum';
import {
  currencyMask,
  unMaskPrice,
  formatDate,
  makeToastSuccess,
  makeToastFaile,
} from '@/utils/common';
import {
  COMMISSION_PROGRAM_TYPE,
  COMMISSION_PROGRAM_STATUS,
  COMMISSION_PROGRAM_STATUS_NAME,
  COMMISSION_STORE_SCOPE_NAME,
  COMMISSION_OPERATOR_OPTIONS,
  toOptionList,
} from './commission.constants';
import commissionReportMixin from './commissionReport.mixin';

const DATE_INPUT_FORMAT = 'DD/MM/YYYY';
const DATE_API_FORMAT = 'YYYY-MM-DD';

export default {
  mixins: [validationMixin, commissionReportMixin],
  components: {
    KTCodePreview,
    datePicker,
    VueMultiSelect,
  },
  data() {
    return {
      AMOUNT_TYPE,
      mask: currencyMask,
      isSubmitting: false,
      isSearchingCategory: false,
      programType: COMMISSION_PROGRAM_TYPE.STORE,
      mainModel: {
        id: null,
        name: '',
        description: '',
        startDate: moment().format(DATE_INPUT_FORMAT),
        endDate: '',
        status: COMMISSION_PROGRAM_STATUS.ACTIVE,
        applyAllRetail: false,
        applyAllWholesale: false,
        retailStores: [],
        wholesaleStores: [],
        departmentId: null,
        details: [],
        exclusions: [],
      },
      stores: [],
      departments: [],
      jobTitles: [],
      searchCategory: '',
      filteredCategoryOptions: [{ data: [] }],
      selectedJobTitleId: null,
      rewardRateModel: {
        detailKey: null,
        categoryName: '',
        rows: [],
      },
      exclusionForm: {
        billNumber: '',
        reason: '',
      },
      overlaps: [],
      statusOptions: toOptionList(COMMISSION_PROGRAM_STATUS_NAME),
      operatorOptions: COMMISSION_OPERATOR_OPTIONS.map((option) => ({
        value: option.value,
        text: option.text,
      })),
      rateTypeOptions: [
        { value: AMOUNT_TYPE.MONEY, text: 'Tiền' },
        { value: AMOUNT_TYPE.PERCENT, text: 'Phần trăm' },
      ],
      detailFields: [
        {
          key: 'count',
          label: 'STT',
          thStyle: { fontWeight: 600, color: '#181c32', width: '5%' },
          tdClass: 'text-center',
        },
        {
          key: 'categoryName',
          label: 'Tên nhóm',
          thStyle: { fontWeight: 600, color: '#181c32', width: '24%' },
        },
        {
          key: 'amount1',
          label: 'Giá trị 1',
          thStyle: { fontWeight: 600, color: '#181c32', width: '13%' },
        },
        {
          key: 'amountOperator1',
          label: 'Toán tử 1',
          thStyle: { fontWeight: 600, color: '#181c32', width: '9%' },
        },
        {
          key: 'revenue',
          label: 'DT',
          thStyle: { fontWeight: 600, color: '#181c32', width: '5%' },
        },
        {
          key: 'amountOperator2',
          label: 'Toán tử 2',
          thStyle: { fontWeight: 600, color: '#181c32', width: '9%' },
        },
        {
          key: 'amount2',
          label: 'Giá trị 2',
          thStyle: { fontWeight: 600, color: '#181c32', width: '13%' },
        },
        {
          key: 'employeeRates',
          label: 'Mức thưởng',
          thStyle: { fontWeight: 600, color: '#181c32', width: '17%' },
        },
        {
          key: 'actions',
          label: '',
          thStyle: { fontWeight: 600, color: '#181c32', width: '5%' },
          tdClass: 'text-center',
        },
      ],
      rewardRateFields: [
        {
          key: 'jobTitleName',
          label: 'Vị trí công việc',
          thStyle: { fontWeight: 600, color: '#181c32', width: '45%' },
        },
        {
          key: 'rateType',
          label: 'Loại',
          thStyle: { fontWeight: 600, color: '#181c32', width: '25%' },
        },
        {
          key: 'value',
          label: 'Giá trị',
          thStyle: { fontWeight: 600, color: '#181c32', width: '25%' },
        },
        {
          key: 'actions',
          label: '',
          thStyle: { fontWeight: 600, color: '#181c32', width: '5%' },
          tdClass: 'text-center',
        },
      ],
      exclusionFields: [
        {
          key: 'count',
          label: 'STT',
          thStyle: { fontWeight: 600, color: '#181c32', width: '5%' },
          tdClass: 'text-center',
        },
        {
          key: 'billNumber',
          label: 'Mã hóa đơn',
          thStyle: { fontWeight: 600, color: '#181c32', width: '25%' },
        },
        {
          key: 'reason',
          label: 'Lý do',
          thStyle: { fontWeight: 600, color: '#181c32', width: '65%' },
        },
        {
          key: 'actions',
          label: '',
          thStyle: { fontWeight: 600, color: '#181c32', width: '5%' },
          tdClass: 'text-center',
        },
      ],
      overlapFields: [
        { key: 'storeName', label: 'Cửa hàng' },
        { key: 'scope', label: 'Kênh' },
        { key: 'programName', label: 'Chương trình' },
        { key: 'period', label: 'Khoảng thời gian' },
      ],
    };
  },
  validations: {
    mainModel: {
      name: { required },
      startDate: { required },
    },
  },
  computed: {
    isUpdate() {
      return Boolean(this.mainModel.id);
    },
    isStoreProgram() {
      return this.programType === COMMISSION_PROGRAM_TYPE.STORE;
    },
    pageTitle() {
      const scope = this.isStoreProgram
        ? 'chương trình hoa hồng cửa hàng'
        : 'chương trình hoa hồng CR';
      return this.isUpdate ? `Cập nhật ${scope}` : `Thêm mới ${scope}`;
    },
    /** Chỉ 2 trạng thái, chuyển qua lại tự do */
    allowedStatusOptions() {
      return this.statusOptions;
    },
    /** Vị trí chưa được thêm vào bậc đang mở modal */
    availableJobTitles() {
      const usedIds = this.rewardRateModel.rows.map((row) => row.jobTitleId);
      return this.jobTitles.filter(
        (jobTitle) => !usedIds.includes(jobTitle.id),
      );
    },
  },
  created() {
    this.initialStatus = COMMISSION_PROGRAM_STATUS.ACTIVE;
    this.resolveProgramType();

    if (this.isStoreProgram) {
      this.fetchStores();
    } else {
      this.fetchDepartments();
    }
    this.fetchJobTitles();

    // ?id=      -> sửa chương trình đang có
    // ?copyFrom= -> SAO CHÉP: nạp y nguyên dữ liệu nguồn nhưng KHÔNG gán id,
    //               nên form vẫn ở chế độ tạo mới. Người dùng sửa rồi bấm Tạo.
    const id = this.$route.query.id;
    const copyFrom = this.$route.query.copyFrom;
    if (id) {
      this.fetchProgram(id);
    } else if (copyFrom) {
      this.fetchProgram(copyFrom, true);
    }

    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Hoa hồng V2', route: this.listRoute() },
      {
        title: id
          ? 'Cập nhật chương trình'
          : copyFrom
            ? 'Sao chép chương trình'
            : 'Thêm mới chương trình',
      },
    ]);
  },
  methods: {
    resolveProgramType() {
      const type = Number(this.$route.query.type);
      this.programType =
        type === COMMISSION_PROGRAM_TYPE.CR
          ? COMMISSION_PROGRAM_TYPE.CR
          : COMMISSION_PROGRAM_TYPE.STORE;
    },
    listRoute() {
      return this.programType === COMMISSION_PROGRAM_TYPE.CR
        ? '/commission/programs-cr'
        : '/commission/programs-store';
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.mainModel[name];
      return $dirty ? !$error : null;
    },
    formatShortDate(value) {
      return value ? formatDate(value, DATE_INPUT_FORMAT) : '';
    },
    scopeName(scope) {
      return COMMISSION_STORE_SCOPE_NAME[scope] || '';
    },
    toApiDate(value) {
      if (!value) {
        return null;
      }
      const parsed = moment(value, DATE_INPUT_FORMAT, true);
      return parsed.isValid() ? parsed.format(DATE_API_FORMAT) : null;
    },
    fetchStores() {
      ApiService.setHeader();
      ApiService.query('stores', { params: { limit: 1000, page: 1 } })
        .then(({ data }) => {
          this.stores = (data.data.list_store || []).map((store) => ({
            id: store.id,
            name: `${store.shortName} (${store.name})`,
          }));
        })
        .catch(() => {
          makeToastFaile('Không tải được danh sách cửa hàng!');
        });
    },
    fetchDepartments() {
      ApiService.setHeader();
      ApiService.query('employees/departments')
        .then(({ data }) => {
          this.departments = data.data || [];
        })
        .catch(() => {
          makeToastFaile('Không tải được danh sách bộ phận!');
        });
    },
    fetchJobTitles() {
      ApiService.setHeader();
      ApiService.query('commission-job-titles/allowed', {
        params: { commissionType: this.programType },
      })
        .then(({ data }) => {
          this.jobTitles = data.data || [];
        })
        .catch(() => {
          makeToastFaile('Không tải được danh sách vị trí công việc!');
        });
    },
    /**
     * Nạp dữ liệu chương trình vào form.
     * @param {number|string} id
     * @param {boolean} isCopy - true = sao chép: giữ nguyên cấu hình nhưng KHÔNG
     *   gán id (form ở chế độ tạo mới) và thêm hậu tố vào tên để không trùng.
     */
    fetchProgram(id, isCopy = false) {
      ApiService.setHeader();
      ApiService.query(`commission-programs/${id}`)
        .then(({ data }) => {
          const program = data.data || {};
          this.mainModel.id = isCopy ? null : program.id;
          this.mainModel.name = isCopy
            ? `${program.name} - Copy`
            : program.name;
          this.mainModel.description = program.description;
          this.mainModel.startDate = program.startDate
            ? moment(program.startDate).format(DATE_INPUT_FORMAT)
            : '';
          this.mainModel.endDate = program.endDate
            ? moment(program.endDate).format(DATE_INPUT_FORMAT)
            : '';
          this.mainModel.status = isCopy
            ? COMMISSION_PROGRAM_STATUS.ACTIVE
            : program.status;
          this.initialStatus = this.mainModel.status;
          this.mainModel.departmentId = program.departmentId || null;
          this.mainModel.applyAllRetail = Boolean(
            program.applyAllRetailStores,
          );
          this.mainModel.applyAllWholesale = Boolean(
            program.applyAllWholesaleStores,
          );
          this.mainModel.retailStores = this.mapStores(program.retailStores);
          this.mainModel.wholesaleStores = this.mapStores(
            program.wholesaleStores,
          );
          this.mainModel.details = (program.details || []).map((detail) =>
            this.mapDetailFromApi(detail),
          );
          this.mainModel.exclusions = (program.exclusions || []).map(
            (exclusion) => ({
              id: exclusion.id,
              billNumber: exclusion.billNumber,
              reason: exclusion.reason,
            }),
          );
        })
        .catch((error) => {
          makeToastFaile(
            this.getErrorMessage(error, 'Không tải được chương trình!'),
          );
        });
    },
    mapStores(programStores) {
      return (programStores || []).map((store) => ({
        id: store.storeId,
        name: store.storeName,
      }));
    },
    mapDetailFromApi(detail) {
      return {
        key: this.buildDetailKey(detail.commissionCategoryId),
        id: detail.id,
        commissionCategoryId: detail.commissionCategoryId,
        categoryName: detail.commissionCategoryName || detail.categoryName,
        amount1: detail.amount1 === null ? '' : this.toInputMoney(detail.amount1),
        amount2: detail.amount2 === null ? '' : this.toInputMoney(detail.amount2),
        amountOperator1: detail.amount1Operator || OPERATOR_TYPE.NONE,
        amountOperator2: detail.amount2Operator || OPERATOR_TYPE.NONE,
        employeeRates: (detail.employeeRates || []).map((employee) => ({
          jobTitleId: employee.jobTitleId,
          jobTitleName: employee.jobTitleName,
          rateType: employee.rateType || AMOUNT_TYPE.MONEY,
          amount: employee.amount ? this.toInputMoney(employee.amount) : '',
          percent: employee.percent || 0,
        })),
      };
    },
    /**
     * Số tiền từ API → chuỗi cho ô nhập: phải dùng dấu phẩy ngăn nghìn (en-US) cho khớp
     * currencyMask và unMaskPrice. Định dạng vi-VN (dấu chấm) làm 500.000 lưu lại thành 500.
     */
    toInputMoney(value) {
      return Number(value).toLocaleString('en-US', { maximumFractionDigits: 2 });
    },
    buildDetailKey(commissionCategoryId) {
      return `${commissionCategoryId}-${Date.now()}-${Math.random()
        .toString(36)
        .slice(2, 8)}`;
    },
    onToggleApplyAllRetail(checked) {
      if (checked) {
        this.mainModel.retailStores = [];
      }
    },
    onToggleApplyAllWholesale(checked) {
      if (checked) {
        this.mainModel.wholesaleStores = [];
      }
    },
    onInputChangeCategory(text) {
      this.searchCategory = text;
      this.debounceSearchCategory();
    },
    debounceSearchCategory: decounce(function () {
      if (!this.isSearchingCategory) {
        this.fetchCategorySuggestions(this.searchCategory);
      }
    }, TIME_TRIGGER),
    fetchCategorySuggestions(textSearch) {
      this.isSearchingCategory = true;
      ApiService.setHeader();
      ApiService.query('commission-categories/search', {
        params: { name: textSearch || undefined, limit: 20 },
      })
        .then(({ data }) => {
          const result = data.data;
          this.filteredCategoryOptions = [
            { data: Array.isArray(result) ? result : result.data || [] },
          ];
        })
        .catch(() => {
          this.filteredCategoryOptions = [{ data: [] }];
        })
        .finally(() => {
          this.isSearchingCategory = false;
          if (textSearch !== this.searchCategory) {
            this.fetchCategorySuggestions(this.searchCategory);
          }
        });
    },
    onSelectedCategory(option) {
      this.searchCategory = '';
      const category = option.item;
      this.mainModel.details.push({
        key: this.buildDetailKey(category.id),
        id: null,
        commissionCategoryId: category.id,
        categoryName: category.name,
        amount1: '',
        amount2: '',
        amountOperator1: OPERATOR_TYPE.NONE,
        amountOperator2: OPERATOR_TYPE.NONE,
        employeeRates: [],
      });
    },
    showRemoveDetailAlert(item) {
      Swal.fire({
        title: 'Xóa chi tiết hoa hồng',
        text: `Bạn có chắc muốn xóa chi tiết của nhóm "${item.categoryName}" không?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(221, 51, 51)',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: 'Xóa',
        cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
        reverseButtons: true,
        position: 'top',
      }).then((result) => {
        if (result.value) {
          this.mainModel.details = this.mainModel.details.filter(
            (detail) => detail.key !== item.key,
          );
        }
      });
    },
    showRewardRateModal(item) {
      this.selectedJobTitleId = null;
      this.rewardRateModel = {
        detailKey: item.key,
        categoryName: item.categoryName,
        rows: (item.employeeRates || []).map((employee) => ({
          ...employee,
        })),
      };
      this.$refs['reward-rate-modal'].show();
    },
    hideRewardRateModal() {
      this.$refs['reward-rate-modal'].hide();
    },
    addRewardRate() {
      const jobTitle = this.jobTitles.find(
        (item) => item.id === this.selectedJobTitleId,
      );
      if (!jobTitle) {
        return;
      }
      this.rewardRateModel.rows.push({
        jobTitleId: jobTitle.id,
        jobTitleName: jobTitle.name,
        rateType: AMOUNT_TYPE.MONEY,
        amount: '',
        percent: 0,
      });
      this.selectedJobTitleId = null;
    },
    removeRewardRate(item) {
      this.rewardRateModel.rows = this.rewardRateModel.rows.filter(
        (row) => row.jobTitleId !== item.jobTitleId,
      );
    },
    saveRewardRate() {
      const detail = this.mainModel.details.find(
        (item) => item.key === this.rewardRateModel.detailKey,
      );
      if (detail) {
        detail.employeeRates = this.rewardRateModel.rows.map((row) => ({
          ...row,
        }));
      }
      this.hideRewardRateModal();
    },
    addExclusion() {
      const billNumber = (this.exclusionForm.billNumber || '').trim();
      if (!billNumber) {
        makeToastFaile('Vui lòng nhập mã hóa đơn cần loại trừ!');
        return;
      }
      const isDuplicated = this.mainModel.exclusions.some(
        (exclusion) => exclusion.billNumber === billNumber,
      );
      if (isDuplicated) {
        makeToastFaile('Mã hóa đơn này đã có trong danh sách loại trừ!');
        return;
      }
      this.mainModel.exclusions.push({
        id: null,
        billNumber,
        reason: (this.exclusionForm.reason || '').trim(),
      });
      this.exclusionForm.billNumber = '';
      this.exclusionForm.reason = '';
    },
    showRemoveExclusionAlert(item) {
      Swal.fire({
        title: 'Bỏ loại trừ hóa đơn',
        text: `Bạn có chắc muốn bỏ hóa đơn "${item.billNumber}" khỏi danh sách loại trừ không?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(221, 51, 51)',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: 'Xóa',
        cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
        reverseButtons: true,
        position: 'top',
      }).then((result) => {
        if (result.value) {
          this.removeExclusion(item);
        }
      });
    },
    removeExclusion(item) {
      const dropLocally = () => {
        this.mainModel.exclusions = this.mainModel.exclusions.filter(
          (exclusion) => exclusion !== item,
        );
      };
      if (!item.id) {
        dropLocally();
        return;
      }
      ApiService.setHeader();
      ApiService.delete(`commission-programs/exclusions/${item.id}`).then(
        (response) => {
          // ApiService.delete đã tự toast lỗi và trả về đối tượng error khi thất bại
          if (!response || !response.data) {
            return;
          }
          makeToastSuccess(
            response.data.message || 'Bỏ loại trừ hóa đơn thành công!',
          );
          dropLocally();
        },
      );
    },
    /**
     * Để trống = không giới hạn (NULL), khác hẳn số 0. Xem §4.10.
     */
    toAmount(value) {
      if (value === null || value === undefined || String(value).trim() === '') {
        return null;
      }
      return unMaskPrice(value);
    },
    buildStorePayload(scopeStores, applyAll) {
      if (!this.isStoreProgram || applyAll) {
        return [];
      }
      return scopeStores.map((store) => ({ storeId: store.id }));
    },
    buildPayload() {
      return {
        type: this.programType,
        name: this.mainModel.name.trim(),
        description: this.mainModel.description,
        startDate: this.toApiDate(this.mainModel.startDate),
        endDate: this.toApiDate(this.mainModel.endDate),
        status: this.mainModel.status,
        applyAllRetailStores: this.isStoreProgram
          ? this.mainModel.applyAllRetail
          : false,
        applyAllWholesaleStores: this.isStoreProgram
          ? this.mainModel.applyAllWholesale
          : false,
        retailStores: this.buildStorePayload(
          this.mainModel.retailStores,
          this.mainModel.applyAllRetail,
        ),
        wholesaleStores: this.buildStorePayload(
          this.mainModel.wholesaleStores,
          this.mainModel.applyAllWholesale,
        ),
        departmentId: this.isStoreProgram ? null : this.mainModel.departmentId,
        details: this.mainModel.details.map((detail) => ({
          id: detail.id,
          commissionCategoryId: detail.commissionCategoryId,
          amount1: this.toAmount(detail.amount1),
          amount1Operator: detail.amountOperator1,
          amount2: this.toAmount(detail.amount2),
          amount2Operator: detail.amountOperator2,
          employeeRates: (detail.employeeRates || []).map((employee) => ({
            jobTitleId: employee.jobTitleId,
            rateType: employee.rateType,
            amount:
              employee.rateType === AMOUNT_TYPE.MONEY
                ? unMaskPrice(employee.amount || 0)
                : null,
            percent:
              employee.rateType === AMOUNT_TYPE.PERCENT
                ? employee.percent
                : null,
          })),
        })),
        exclusions: this.mainModel.exclusions.map((exclusion) => ({
          id: exclusion.id,
          billNumber: exclusion.billNumber,
          reason: exclusion.reason,
        })),
      };
    },
    validateBeforeSubmit() {
      const startDate = this.toApiDate(this.mainModel.startDate);
      const endDate = this.toApiDate(this.mainModel.endDate);
      if (!startDate) {
        makeToastFaile('Ngày bắt đầu không hợp lệ!');
        return false;
      }
      if (endDate && moment(endDate).isBefore(startDate)) {
        makeToastFaile('Ngày kết thúc phải sau hoặc bằng ngày bắt đầu!');
        return false;
      }
      if (!this.mainModel.details.length) {
        makeToastFaile(
          'Chương trình hoạt động phải có ít nhất 1 chi tiết hoa hồng!',
        );
        return false;
      }
      const missingRate = this.mainModel.details.find(
        (detail) => !(detail.employeeRates || []).length,
      );
      if (missingRate) {
        makeToastFaile(
          `Nhóm "${missingRate.categoryName}" chưa có mức thưởng cho vị trí nào!`,
        );
        return false;
      }
      return true;
    },
    onSubmit() {
      this.$v.mainModel.$touch();
      if (this.$v.mainModel.$anyError) {
        return;
      }
      if (!this.validateBeforeSubmit()) {
        return;
      }

      const payload = this.buildPayload();
      this.isSubmitting = true;
      ApiService.setHeader();
      const request = this.isUpdate
        ? ApiService.put(`commission-programs/${this.mainModel.id}`, payload)
        : ApiService.post('commission-programs', payload);

      request
        .then(({ data }) => {
          // BE trả lỗi nghiệp vụ bằng HTTP 201 + status 0 — không được coi là thành công
          if (!data || data.status !== 1) {
            this.handleSubmitError({ response: { data } });
            return;
          }
          makeToastSuccess(
            data.message ||
              (this.isUpdate
                ? 'Cập nhật chương trình thành công!'
                : 'Tạo chương trình thành công!'),
          );
          this.$router.push(this.listRoute());
        })
        .catch((error) => {
          this.handleSubmitError(error);
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    /**
     * BE chặn khi phát hiện chồng lấn (§4.17) và trả kèm danh sách chi tiết
     * gồm cửa hàng, kênh, chương trình và khoảng thời gian bị trùng.
     */
    handleSubmitError(error) {
      const responseData =
        error && error.response ? error.response.data : null;
      const overlaps =
        responseData && responseData.data ? responseData.data.overlaps : null;

      if (Array.isArray(overlaps) && overlaps.length) {
        this.overlaps = overlaps;
        this.$refs['overlap-modal'].show();
        return;
      }
      makeToastFaile(
        this.getErrorMessage(error, 'Lưu chương trình hoa hồng thất bại!'),
      );
    },
    onBack() {
      this.$router.push(this.listRoute());
    },
  },
};
</script>

<style>
.no-spinner::-webkit-outer-spin-button,
.no-spinner::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.no-spinner[type='number'] {
  -moz-appearance: textfield;
}

.commission-link {
  cursor: pointer;
  color: #3699ff;
}

.commission-link:hover {
  text-decoration: underline;
}

.multi-select-wrapper {
  flex: 1 1 auto;
}

.autosuggest__results ul {
  list-style: none;
  cursor: pointer;
  margin-bottom: 0;
}

.autosuggest__results {
  position: absolute;
  background-color: #fff;
  z-index: 1;
  width: 100%;
  border: 1px solid #e0e0e0;
  overflow: auto;
  max-height: 200px;
}

.autosuggest__results-container {
  position: relative;
  width: 100%;
}

#autosuggest__input {
  display: block;
  width: 100%;
  padding: 0.55rem 0.75rem;
  font-size: 0.925rem;
  font-weight: 400;
  line-height: 1.35;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.28rem;
  height: calc(1.35em + 1.1rem + 2px);
}

#autosuggest__input:focus {
  outline: none !important;
  border: 1px solid #92c5f9;
}

.autosuggest__results-item:hover {
  background-color: #ddd;
}

.autosuggest__results ul li {
  padding: 8px;
}

.form-group label {
  font-weight: 500;
}
</style>
